import React from "react";
import { Staff } from "../../model/Staff";

export type StackedProps = {
  list: StackedItem[];
};

export type StackedItem = {
  value:Staff;
  isSelected?: boolean;
  event:React.MouseEventHandler;
};

export const StackedLists = ({ list }: StackedProps) => {
  return (
    <div>
      <ul>
        {list.map((item, index) => (
          <li key={`staffList-${index}`} role="list" className="relative divide-y divide-gray-200" onClick={item.event}>
            <div className={`relative flex items-center space-x-3 px-6 py-5 hover:bg-gray-200 ${item.isSelected === true ? "bg-gray-200": ""}`}>
              <div className="min-w-0 flex-1">
                <div className="focus:outline-none">
                  {/* Extend touch target to entire panel */}
                  <span className="absolute inset-0" aria-hidden="true" />
                  <p className="text-sm font-medium text-gray-900">
                    {item.value.displayName}
                  </p>
                  <p className="truncate text-sm text-gray-500">
                    {item.value.email}
                  </p>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
